import React from 'react';
import {
  Box,
  Card,
  Skeleton,
  Divider,
  useTheme,
} from '@ublend-npm/aulaui-core';

export const RecentUpdateCardSkeleton = () => {
  const theme = useTheme();

  return (
    <Card
      sx={{
        borderRadius: 6,
        padding: 2.5,
        boxShadow: 'none',
        border: `1px solid ${theme.palette.divider}`,
        bgcolor: theme.palette.mode === 'dark' ? '#363636' : '#FFFFFF',
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5,
      }}
    >
      <Skeleton
        kind="rounded"
        width={110}
        height={24}
        sx={{ borderRadius: '12px' }}
      />

      <Box display="flex" alignItems="center" gap={1.5}>
        <Skeleton kind="circular" width={40} height={40} />
        <Box flex={1}>
          <Skeleton kind="text" width={120} height={20} sx={{ mb: 0.5 }} />
          <Skeleton kind="text" width={80} height={16} />
        </Box>
      </Box>

      <Box>
        <Skeleton kind="text" width="100%" height={18} sx={{ mb: 0.75 }} />
        <Skeleton kind="text" width="100%" height={18} sx={{ mb: 0.75 }} />
        <Skeleton kind="text" width="100%" height={18} sx={{ mb: 0.75 }} />
        <Skeleton kind="text" width="60%" height={18} />
      </Box>

      <Box display="flex" alignItems="center" gap={3}>
        <Box display="flex" alignItems="center" gap={1}>
          <Skeleton kind="circular" width={20} height={20} />
          <Skeleton kind="text" width={16} height={16} />
        </Box>
        <Box display="flex" alignItems="center" gap={1}>
          <Skeleton kind="rounded" width={20} height={20} />
          <Skeleton kind="text" width={16} height={16} />
        </Box>
      </Box>

      <Divider sx={{ borderColor: theme.palette.divider }} />

      <Box>
        <Skeleton kind="text" width="50%" height={16} />
      </Box>
    </Card>
  );
};

export const PostDetailPopupSkeleton = () => {
  return (
    <Box>
      <Box display="flex" alignItems="center" gap={1.5} mb={2.5}>
        <Skeleton kind="circular" width={44} height={44} />
        <Box>
          <Skeleton kind="text" width={140} height={20} sx={{ mb: 0.5 }} />
          <Skeleton kind="text" width={90} height={16} />
        </Box>
      </Box>

      <Box marginLeft={6}>
        <Box mb={2.5} sx={{ pl: 0.5 }}>
          <Skeleton kind="text" width="85%" height={20} sx={{ mb: 1.5 }} />
          <Skeleton kind="text" width="90%" height={20} sx={{ mb: 1.5 }} />
          <Skeleton kind="text" width="75%" height={20} sx={{ mb: 1.5 }} />
          <Skeleton kind="text" width="88%" height={20} sx={{ mb: 1.5 }} />
          <Skeleton kind="text" width="60%" height={20} sx={{ mb: 1.5 }} />
        </Box>

        <Skeleton
          kind="rounded"
          width="100%"
          height={280}
          sx={{ borderRadius: 2, mb: 1 }}
        />

        <Skeleton kind="text" width={60} height={14} sx={{ mb: 2.5 }} />
      </Box>
      <Divider sx={{ mb: 2 }} />

      <Skeleton
        kind="rounded"
        width={40}
        height={32}
        sx={{ borderRadius: 4 }}
      />
    </Box>
  );
};

export const RecentUpdatesSkeleton = ({
  orientation,
}: {
  orientation: 'vertical' | 'horizontal';
}) => {
  const isHorizontal = orientation === 'horizontal';

  return (
    <Box
      display="flex"
      flexDirection={isHorizontal ? 'row' : 'column'}
      gap={2}
      sx={{
        width: '100%',
        maxWidth: '100%',
        minWidth: 0,
        overflowX: isHorizontal ? 'auto' : 'visible',
        pb: isHorizontal ? 2 : 0,
      }}
    >
      {Array.from({ length: 3 }).map((_, index) => (
        <Box
          key={index}
          sx={{
            width: isHorizontal ? '320px' : '100%',
            flexShrink: 0,
          }}
        >
          <RecentUpdateCardSkeleton />
        </Box>
      ))}
    </Box>
  );
};

export default RecentUpdatesSkeleton;
